import { useEffect, useState } from "react";
import { useActivateQuery } from "context/auth/authApiSlice";
import  {useDispatch} from "react-redux";
import { setCredentials } from "context/auth/authSlice";
import CircularProgress from '@mui/material/CircularProgress';
// @mui material components
import { Grid, Link, Container, Card } from "@mui/material";
import { useParams, Link as RouterLink } from "react-router-dom" ;
import CoverLayout from "components/layouts/CoverLayout";
// Material Kit 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

// Images
import bgImage from "assets/images/bg-profile.jpeg";

function AcountActivation() {

    const {id,rand} = useParams();
    const dispatch = useDispatch();

    const {
      data: profile,
      isLoading,
      isSuccess,
      isError,
      error
    } = useActivateQuery({id,rand}, {
        skip : /^[A-Za-z0-9-_]*$/.test(id) === false,
        refetchOnMountOrArgChange: true
    })

    useEffect(() => {
      if(isSuccess){
        dispatch(setCredentials({accessToken : profile.accessToken,  user: profile.user}));
      }
    }, [isSuccess])
    
  return (
    <CoverLayout rest coverHeight="50vh" lg={12} image={bgImage}>
        <Card
            sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
            >
            <Container sx={{my:4}}>      
              <Grid container spacing={3} alignItems="center">
              
                <Grid
                  item
                  xs={12}
                  sm={10}
                  md={7}
                  ml={{ xs: "auto" }}
                  mr={{ xs: "auto"}}
                >
                  <MDBox
                    borderRadius="xl"
                    shadow="lg"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    mt={5}
                    mb={5}
                    mx={3}
                  >
                    {/* eslint-disable */}
                    <MDBox
                      variant="gradient"
                      bgColor={isError ? "warning" : isSuccess ? "success" :  "info"}
                      coloredShadow="info"
                      borderRadius="lg"
                      p={2}
                      mx={2}
                      mt={-3}
                    >
                      <MDTypography variant="h3" color="white">
                      {isSuccess ? "Congratulations !!" : isError ? "Sorry !!" : !isLoading && "Welcome"}
                      {isLoading && <MDBox color="white" sx={{ display: 'inline-flex' }}> <CircularProgress thickness={4} sx={{mx:1}} color="white" size={30}/> Please wait..</MDBox>}
                      </MDTypography>
                    </MDBox>
                    <MDBox p={3}>  
                      {isError ? <MDTypography variant="h6" color="text" mb={1}>
                        Votre lien d'activation ne fonctionne pas !!, c'est parce que <MDTypography variant="h6" sx={{display:"inline-block"}} color="error" mb={1}>{error.data?.message}</MDTypography> 
                                </MDTypography>
                      : <MDTypography variant="body2" color="text" mb={3}>
                      Merci de votre intérêt pour notre site Internet. nous vous remercions d'avoir pris le temps de vous abonner et de rejoindre notre communauté.
                        </MDTypography>}
                      {isSuccess && <>
                        <MDTypography sx={{ mb:2}} variant="subtitle1">Votre compte a été <MDTypography sx={{display:'inline-block', mx:.5}} component="b"> activé </MDTypography> à présent, vous pouvez visiter votre<Link color="info.light" sx={{ml:1,  transition :"all ease-in-out .5s", '&:hover':{
                            color : ({palette}) => palette.info.dark,
                            fontWeight : 500,
                            }}} underline="none" component={RouterLink} to='/authentication/sign-in'>Sign-In</Link></MDTypography>
                        </>}
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </Container>
          </Card>
    </CoverLayout>
  );
}

export default AcountActivation;
